import flatten from 'lodash/flatten';
import UserService from '../services/user';

const extractPermissions = binding => (binding.arg ? binding.arg.split(',') : flatten([...binding.value]));

const requiresPermissionBase = checker => ({
  inserted(el, binding, vnode) {
    const permissions = extractPermissions(binding);
    if (!checker(permissions)) {
      vnode.elm.parentNode.removeChild(vnode.elm);
    }
  },
});

const requiresPermission = requiresPermissionBase(
  permissions => UserService.hasPermission(...permissions),
);
const requiresAnyPermission = requiresPermissionBase(
  permissions => UserService.hasAnyPermission(...permissions),
);

export default {
  install(Vue) {
    Vue.directive('requires-permission', requiresPermission);
    Vue.directive('requires-any-permission', requiresAnyPermission);
  },
};
